import { Box, styled, Typography } from "@mui/material";
import React from "react";

const CardHeader = ({ teamName, currentScore = 0, isVotingStarted = false }) => {
console.log("🚀 ~ CardHeader ~ isVotingStarted:", isVotingStarted)

  const Img = styled("img")(() => ({
    display: "block",
    width: "clamp(2.5rem, 10vw, 3.75rem)",
    height: "clamp(2.5rem, 10vw, 3.75rem)",
  }));

  var logoSrc = `/img/team-logo/${teamName}.png`;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      margin={-1}
      sx={{
        padding: { xs: '0.625rem 0.75rem', md: '0.75rem 1rem' },
        background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.95) 0%, rgba(101, 67, 33, 0.92) 100%)',
        backdropFilter: 'blur(10px)',
        borderRadius: { xs: '0.75rem 0.75rem 0 0', md: '1rem 1rem 0 0' },
        borderBottom: '0.2rem solid rgba(218, 165, 32, 0.7)',
        position: 'relative',
        overflow: 'hidden',
        flexWrap: { xs: 'wrap', sm: 'nowrap' },
        gap: { xs: 1, sm: 0 },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '-100%',
          width: '100%',
          height: '100%',
          background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
          animation: 'shimmer 3s infinite',
        }
      }}
    >
      <div className="flex items-center gap-2 md:gap-3 animate-slide-in-top">
        <Box
          sx={{
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              top: '-0.3rem',
              left: '-0.3rem',
              right: '-0.3rem',
              bottom: '-0.3rem',
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(255, 215, 0, 0.3), transparent 70%)',
              animation: 'pulse-glow 2s ease-in-out infinite',
              zIndex: 0,
            }
          }}
        >
          <Img
            src={logoSrc}
            className="animate-float"
            sx={{
              position: 'relative',
              zIndex: 1,
              filter: 'drop-shadow(0 0.125rem 0.25rem rgba(0,0,0,0.3))',
            }}
          />
        </Box>
        <Typography
          gutterBottom
          component="div"
          sx={{
            margin: 0,
            fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
            fontFamily: "'Cinzel', serif",
            fontWeight: 700,
            color: '#fff',
            textShadow: '0.125rem 0.125rem 0.25rem rgba(0,0,0,0.7), 0 0 0.625rem rgba(218, 165, 32, 0.5)',
            letterSpacing: '0.0625rem',
          }}
        >
          {teamName}
        </Typography>
      </div>
      {isVotingStarted && (
        <div className="flex items-center gap-1 md:gap-2 animate-scale-in">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 0.5, md: 1 },
              padding: { xs: '0.375rem 0.75rem', md: '0.5rem 1rem' },
              background: 'linear-gradient(135deg, rgba(218, 165, 32, 0.3) 0%, rgba(184, 134, 11, 0.2) 100%)',
              borderRadius: '1.5rem',
              border: '0.125rem solid rgba(255, 215, 0, 0.4)',
              boxShadow: '0 0 1rem rgba(218, 165, 32, 0.3), inset 0 0.0625rem 0 rgba(255, 255, 255, 0.1)',
            }}
          >
            <Typography
              component="div"
              sx={{
                margin: 0,
                fontSize: { xs: '0.9rem', md: '1.1rem' },
                fontFamily: "'Philosopher', sans-serif",
                color: '#FFD700',
                textShadow: '0.0625rem 0.0625rem 0.2rem rgba(0,0,0,0.8)',
              }}
            >
              Score:
            </Typography>
            <Typography
              component="div"
              sx={{
                margin: 0,
                fontSize: { xs: '1.1rem', md: '1.3rem' },
                fontFamily: "'Cinzel', serif",
                fontWeight: 900,
                color: '#FFF',
                textShadow: '0.125rem 0.125rem 0.25rem rgba(0,0,0,0.8), 0 0 0.625rem rgba(255, 215, 0, 0.8)',
                background: 'linear-gradient(180deg, #FFD700 0%, #FFA500 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                filter: 'drop-shadow(0 0.125rem 0.2rem rgba(0,0,0,0.5))',
                minWidth: { xs: '3rem', md: '3.75rem' },
                textAlign: 'center',
              }}
              className="animate-count-up"
            >
              {currentScore}
            </Typography>
          </Box>
        </div>
      )}
    </Box>
  );
};

export default CardHeader;
